import {Component, HostBinding, HostListener, Input, NgZone} from "@angular/core";
import {FUIFormContext} from "../../form-context/form-context";
import {FUIEventsService} from "../../events/events.service";

@Component({
    selector: "fui-page-subject",
    styleUrls: ["./page-subject.component.scss"],
    templateUrl: "./page-subject.component.html",
    providers: [{provide: FUIFormContext, useClass: FUIPageSubjectComponent}]
})
export class FUIPageSubjectComponent {
    @Input() masked: boolean;
    @Input() @HostBinding("class.scrolled") public scrolled: boolean = true;

    constructor(private eventsService: FUIEventsService,
                private ngZone: NgZone) {
        this.ngZone.runOutsideAngular(() => {
            document.addEventListener("touchend", event => this.touchEnd(event));
            document.addEventListener("touchmove", event => this.touchMove(event));
            document.addEventListener("touchstart", event => this.touchStart(event));
        })
    }

    /**
     * Track scrolling events
     * @param {Event} $event
     */
    @HostListener("scroll", ["$event"])
    public scroll($event: Event) {
        this.eventsService.scroll = $event;
    }

    /**
     * Track touch end events
     * @param {Event} $event
     */
    touchEnd($event: TouchEvent) {
        this.eventsService.touch = $event;
    }

    /**
     * Track touch movements
     * @param {Event} $event
     */
    touchMove($event: TouchEvent): void {
        this.eventsService.touch = $event;
    }

    /**
     * Track touch start
     * @param {Event} $event
     */
    touchStart($event: TouchEvent): void {
        this.eventsService.touch = $event;
    }
}
